var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Platform, NativeModules } from 'react-native';
import { CoreConfig } from './CoreConfig';
import { Observable, Provider, ProvidersMap } from './Data';
import { IApplicationRepositoryType, ICacheDataSourceType, IPayloadRepositoryType } from './Domain';
import { IEventsDataSourceType } from './Data/DataSource/EventsDataSource/IEventsDataSource';
import { uuid } from './Helpers';
function applicationFactory() {
    let globalProviders = [CoreConfig.provider];
    return {
        id: uuid(),
        providers: new ProvidersMap(),
        addGlobalProvider(provider) {
            if (!globalProviders.includes(provider)) {
                globalProviders.push(provider);
            }
            return globalProviders;
        },
        createProvider(token, autodestroy) {
            const provider = new Provider(this.providers, token, autodestroy);
            globalProviders.forEach(key => {
                const globalProvider = this.providers.loadProvider(key);
                if (!globalProvider) {
                    return;
                }
                globalProvider.getRegistrations().forEach(registration => {
                    !registration.proxy && registration.provider === globalProvider.token && provider.bind(registration.dependencyKey).withProxy({
                        provider: globalProvider.token,
                        type: registration.dependencyKey
                    });
                });
            });
            return provider;
        },
        update(moduleName, value) {
            this.registerModule(moduleName);
            value.state && this.updateState(value.state);
            value.payload && this.updatePayload(moduleName, value.payload);
            value.onEvent && registerEventHandler(moduleName, value.onEvent);
        },
        registerModule(module) {
            const provider = this.providers.getProvider(CoreConfig.provider);
            const applicationRepository = provider === null || provider === void 0 ? void 0 : provider.resolveSync(IApplicationRepositoryType);
            applicationRepository === null || applicationRepository === void 0 ? void 0 : applicationRepository.registerModule(module);
        },
        updateState(value) {
            const provider = this.providers.getProvider(CoreConfig.provider);
            const cache = provider === null || provider === void 0 ? void 0 : provider.resolveSync(ICacheDataSourceType);
            cache === null || cache === void 0 ? void 0 : cache.updateMany(value);
        },
        updatePayload(moduleName, value) {
            const provider = this.providers.getProvider(CoreConfig.provider);
            const payloadRepository = provider === null || provider === void 0 ? void 0 : provider.resolveSync(IPayloadRepositoryType);
            payloadRepository === null || payloadRepository === void 0 ? void 0 : payloadRepository.updatePayload(moduleName, value);
        },
        didUpdateState: new Observable(),
        didUpdatePayload: new Observable(),
        onError: new Observable(),
        onEvent: new Observable()
    };
}
export const Application = applicationFactory();
function registerEventHandler(moduleName, onEvent) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = Application.providers.getProvider(CoreConfig.provider);
        const eventsRepository = yield (provider === null || provider === void 0 ? void 0 : provider.resolve(IEventsDataSourceType));
        eventsRepository === null || eventsRepository === void 0 ? void 0 : eventsRepository.setOnEvent(moduleName, onEvent);
    });
}
if (Platform.OS !== 'web') {
    Application.onError.subscribe(error => {
        var _a, _b;
        const event = {
            module: CoreConfig.moduleName,
            event: 'error',
            data: { error }
        };
        (_b = (_a = NativeModules.EventsModule) === null || _a === void 0 ? void 0 : _a.onEvent) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    });
}
